import React from "react";
import { MatApoyo } from "../Generals";
import { useSelector } from "react-redux";

export default function Lesson8({ idLesson, data, setLoading, objEntidad, origen }) {
  
  //Se obtiene el Entidad seleccionada del store de redux
  const { entidad, idEntidad } = useSelector((state) => state.entidad);


  if(idEntidad!==undefined){
    localStorage.setItem('idEntidad', idEntidad);
  }

  const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ? objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }

  return (
    <div className="texto_parrafo">
      <p>
        ¡Comencemos con el <b>Voto desde el extranjero!</b>
      </p>
      <p>
        La urna electrónica es un dispositivo electrónico que permite a las personas votar, señalando en una pantalla 
        el partido político, coalición o candidatura de su preferencia, así como una candidatura independiente o una no 
        registrada; de la misma manera permite anular el voto de forma voluntaria. Además, cuenta con un módulo de impresión, 
        en el cual la ciudadanía puede verificar que su voto se haya registrado correctamente a través de un testigo del voto.
      </p>
      <p>
        Debes saber que el INE desarrolló la urna electrónica; ésta permite obtener de manera automática los resultados de la votación. 
      </p>
      <p>
        En la siguiente imagen podrás identificar cuáles son las ventajas de su aplicación:
      </p>
      <img src={ `data:image/jpeg;base64,${data[1].url}`} alt="img" className="imagen" /> <br/>
      <p>
        Ahora te invitamos a conocer el dispositivo. En la siguiente imagen podrás observar cómo se conforma.
      </p>
      <img src={ `data:image/jpeg;base64,${data[2].url}`} alt="img" className="imagen" /> <br/>
      <p>
        A continuación, te decimos cuáles son las principales diferencias en relación con la urna ordinaria:
      </p>
      <p>
        <div className="listPuntoRosa">No hay boletas impresas.</div>
        <div className="listPuntoRosa">Las urnas se habilitan con tarjetas que están bajo resguardo de la o el Presidente de casilla.</div>
        <div className="listPuntoRosa">Las y los electores reciben tarjetas especiales para emitir su voto.</div>
        <div className="listPuntoRosa">El conteo y clasificación de los votos se realiza de forma automática por las urnas.</div>
        <div className="listPuntoRosa">Las urnas se regresarán junto con el paquete electoral.</div>
      </p>
      <p>
        Como observadora u observador electoral, debes prestar atención a que las urnas electrónicas se coloquen frente a una pared, 
        con la finalidad de garantizar la secrecía del voto. 
      </p>
      <p>
        Ahora revisemos lo relativo <b>al Voto Anticipado (VA):</b>
      </p>
      <p>
        Esta modalidad está dirigida a las personas que, por alguna incapacidad o limitación física no pueden acudir de manera presencial 
        a votar, por lo que se le brindarán facilidades para emitir su voto desde su domicilio de manera previa a la Jornada Electoral.
      </p>
      <p>
        Los requisitos mínimos que deben cumplir las personas para ejercer el Voto Anticipado son:
      </p>
      <p>
        <div className="listPuntoRosa">Estar inscritas en la Lista Nominal de Electores y contar con credencial para votar.</div>
        <div className="listPuntoRosa">Residir en el Distrito Electoral Federal en el que se encuentren registradas.</div>
        <div className="listPuntoRosa">Haber solicitado, entre 2018 y 2025, la emisión de la Credencial para Votar desde su domicilio, 
          en apego a lo establecido en el artículo 141 de la Ley General de Instituciones y Procedimientos Electorales.</div>
        <div className="listPuntoRosa">Manifestar su intención de registrarse en la Lista Nominal de Electores con Voto 
          Anticipado (LNEVA) a través de una solicitud de inscripción y que ésta resulte procedente.</div>
      </p>
      <p>
        Esta modalidad de votación se llevará a cabo antes de la Jornada Electoral, para lo cual personal del INE acudirá a cada 
        uno de los domicilios de las personas con voto anticipado con los materiales necesarios para la emisión del voto, 
        garantizando su secrecía. 
      </p>
      <p>
        Documentación requerida:
        <ol>
          <li>Boletas electorales</li>
          <li>Instructivo para votar</li>
          <li>Sobre en el que se resguardarán las boletas</li>
        </ol>
      </p>
      <p>
        De esta forma, las personas con voto anticipado emitirán su voto desde su domicilio, para lo cual podrán auxiliarse de 
        una persona de confianza. Las representaciones de partidos políticos y observadoras/es electorales podrán acompañar los 
        recorridos, pero no podrán ingresar a los domicilios.
      </p>
      <p>
        Una vez emitida la votación, los sobres que contengan los votos permanecerán en resguardo del INE hasta el día de la 
        Jornada Electoral, cuando serán contabilizados en las mesas de escrutinio y cómputo (MEC) del VA. 
      </p>
      <p>
        Las mesas de escrutinio y cómputo del VA se integrarán el 1º de junio de 2025 por ciudadanía doblemente sorteada, designada 
        y capacitada por el INE, y serán quienes registren y cuenten los votos emitidos por las personas inscritas en la Lista Nominal 
        del Electorado con Voto Anticipado.
      </p>
      <p>
        En la imagen se puede observar su conformación:
      </p>
      <img src={ `data:image/jpeg;base64,${data[3].url}`} alt="img" className="imagen" /> <br/>
      <p>
        Las actividades que realizarán las y los funcionarios de las MEC del VA se dividen en cinco momentos, identifícalos a 
        continuación: 
      </p>
      <img src={ `data:image/jpeg;base64,${data[4].url}`} alt="img" className="imagen" /> <br/>
      <p>
        Te invitamos a realizar la siguiente actividad de repaso.
      </p>
      {data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}<br/><br/>
      {//SOLO PARA DURANGO
       parseInt(getDataEntidad().idEntidad) === 10 && 
       <>
        <p>
          Por último, revisaremos el <b>Voto de las Personas en Prisión Preventiva.</b>
        </p>
        <p>
          Modalidad que surge bajo el enfoque progresista que busca maximizar los derechos individuales, respetando los principios 
          pro persona y de presunción de inocencia en materia de seguridad pública.
        </p>
        <p>
          Se llevará a cabo en los centros penitenciarios que cumplan con los estándares de seguridad e infraestructura determinados 
          por las autoridades competentes, y el voto se ejercerá de manera anticipada a la Jornada Electoral. 
        </p>
        <p>
          Los requisitos para el voto de las y los ciudadanos que se encuentran en prisión preventiva son: 
        </p>
        <p>
          <div className="listPuntoRosa">Encontrarse en prisión preventiva y en algún centro penitenciario participante.</div>
          <div className="listPuntoRosa">Estar inscrita o inscrito en la Lista Nominal de Electores.</div>
          <div className="listPuntoRosa">Manifestar su intención de registrarse en la Lista Nominal de Electores en Prisión 
            Preventiva (LNEPP) mediante una solicitud y que ésta haya resultado procedente.</div>
        </p>
        <p>
          La LNEPP se generará por entidad federativa, Distrito Electoral Federal, municipio y, en su caso, por Distrito Electoral 
          Local. Incluye a las personas cuyas solicitudes fueron aprobadas y a aquellas que se incorporan a la lista por orden del 
          Tribunal Electoral del Poder Judicial de la Federación.
        </p>
        <p>
          El INE designará al personal responsable de recabar los votos, por lo que se habilitará un área de votación en cada centro 
          penitenciario participante para que las y los ciudadanos en prisión preventiva con solicitud dictaminada como procedente 
          reciban por lo menos los siguientes documentos:
        </p>
        <p>
          <div className="listPuntoRosa">Instructivo de votación</div>
          <div className="listPuntoRosa">Resumen de opciones electorales</div>
          <div className="listPuntoRosa">La o las boletas electorales</div>
          <div className="listPuntoRosa">Sobre para enviar el voto</div>
        </p>
        <p>
          Posteriormente, los sobres con votos se trasladarán a la sede de la Junta Distrital correspondiente para que sean contabilizados 
          el <b>1º de junio de 2025</b> en las mesas de escrutinio y cómputo del Voto de las Personas en Prisión Preventiva (MEC VPPP).
        </p>
        <p>
          Las MEC del VPPP son órganos electorales integrados por funcionarias y funcionarios doblemente insaculados y capacitados por el INE.
        </p>
        <p>
          Las MEC del VPPP se integrarán por:
          <div className="listPuntoRosa">1 Presidenta/e</div>
          <div className="listPuntoRosa">1 Secretaria/o</div>
          <div className="listPuntoRosa">2 escrutadoras/res</div>
          <div className="listPuntoRosa">2 suplentes generales</div>
        </p>
        <p>
          Revisa la siguiente imagen para identificar los cinco momentos en los que se divide la Jornada Electoral para las MEC 
          del VPPP.
        </p>
        <img src={ `data:image/jpeg;base64,${data[6].url}`} alt="img" className="imagen" /> <br/>
       </>
      }
      
      <p>
        No olvides consultar el <b className="textoResaltado2">CAPÍTULO 8 DE TU {data && data.indexOf(8) && <MatApoyo array={[data[8]]} tipo={1}/>}</b> que está disponible 
        en los materiales de consulta de este curso, así como el siguiente material de apoyo para que refuerces tus conocimientos. 
      </p>
      {data && data.indexOf(7) && <MatApoyo array={[data[7]]}/>}
      <p>
        ¡Muy bien! Estás por concluir la lección, realiza la autoevaluación y comprueba cuánto aprendiste sobre las modalidades de la votación.
      </p>
    </div>
  );
}
